import { connect } from 'react-redux';

// Selectors
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import {
  getInsuranceType,
  getOrderComment,
  getSelectedFlightData,
} from 'checkout/store/selectors/order';
import {
  getChosenOptions,
  getExtraOptions,
  getTransferOptions,
} from 'checkout/store/domains/package-upsale-options/selectors';
import {
  getCancellationPolicy,
  getIsInsurable,
} from 'checkout/store/selectors/package';
import { getLtExtras, getTourExtras } from 'checkout/store/selectors/services';

// Actions
import {
  setOptions,
  uncheckOption,
} from 'checkout/store/domains/package-upsale-options/slice';
import {
  changeOrderCommentAction,
  toggleExtraAction,
  toggleInsuranceAction,
} from 'checkout/store/actions/order';

import Services from './Services';

const mapStateToProps = (state) => ({
  tourExtras: getTourExtras(state).filter((extra) => !extra.mandatory),
  ltExtras: getLtExtras(state),
  flightData: getSelectedFlightData(state),
  comment: getOrderComment(state),
  transferList: getTransferOptions(state),
  extrasList: getExtraOptions(state),
  isInsurable: getIsInsurable(state),
  cancellationPolicy: getCancellationPolicy(state),
  ensuranceType: getInsuranceType(state) || undefined,
  isMobile: getIsMobile(state),
  isHotelOnly: getIsHotelOnly(state),
  chosenUpsales: getChosenOptions(state),
});

const mapDispatchToProps = {
  toggleExtras: toggleExtraAction,
  saveComment: changeOrderCommentAction,
  setOptions,
  setInsurance: toggleInsuranceAction,
  uncheckOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);
